import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import graphql from 'graphql';
import { injectGlobal } from 'styled-components';
import {
  PageWrapper,
  mediaQueries,
  spacing,
  colors
} from '../components/Styling';
import { NavBar } from '../components/Navigation';
import { Footer } from '../components/Footer';

injectGlobal([
  `
  body{
    background-color: ${colors.background};
    overflow-x: hidden;
    width: 100vw;
    text-rendering: optimizeLegibility;
  }
  *, *:before, *:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
}
`
]);

const StyledMainContainer = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 105rem;
  min-height: 100vh;
  padding: calc(${spacing[2]} + 3vw);
  padding-bottom: 0;
  width: 100vw;
  transform: ${props =>
    props.navigationActive ? 'translateX(10rem)' : 'none'};
  transition-timing-function: cubic-bezier(0.03, 0.98, 0.52, 0.99);
  transition: transform 0.3s;

  ${mediaQueries.medium`
        padding: ${spacing[6]};
        padding-bottom: 0;
      `};

  ${mediaQueries.large`
        padding: calc(${spacing[7]});
        padding-bottom: 0;
      `};
`;

class MainContainer extends React.Component {
  constructor(props) {
    super(props);
    this.toggleNav = this.toggleNav.bind(this);
    this.state = { navigationActive: false };
  }

  toggleNav(hasValue) {
    this.setState({
      navigationActive:
        hasValue !== undefined && !hasValue
          ? false
          : !this.state.navigationActive
    });
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      if (this.state.navigationActive) this.toggleNav(false);
    });
  }

  render() {
    return (
      <StyledMainContainer
        navigationActive={this.state.navigationActive}
        className={this.props.className}
      >
        <NavBar
          isActive={this.state.navigationActive}
          toggleNav={this.toggleNav}
        />
        {this.props.children}
        <Footer
          soundcloud={this.props.data.markdownRemark.frontmatter.soundcloud}
          facebook={this.props.data.markdownRemark.frontmatter.facebook}
        />
      </StyledMainContainer>
    );
  }
}

const TemplateWrapper = ({ children, data }) => 
  <div>
    <Helmet>
      <title>{data.markdownRemark.frontmatter.metaTitle}</title>
      <meta
        property="og:title"
        content={data.markdownRemark.frontmatter.metaTitle}
      />
      <meta
        property="og:description"
        content={data.markdownRemark.frontmatter.metaDescription}
      />
      <meta
        property="og:image"
        content={`https://grimmsound.com${
          data.markdownRemark.frontmatter.metaImage
        }`}
      />
      <meta
        name="description"
        content={data.markdownRemark.frontmatter.metaDescription}
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.0/normalize.min.css"
      />
      <script
        type="text/javascript"
        src="https://identity.netlify.com/v1/netlify-identity-widget.js"
      />
    </Helmet>

    <MainContainer data={data}>{children()}</MainContainer>
  </div>
;

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;

export const LayoutIndexQuery = graphql`
  query LayoutIndexQuery {
    markdownRemark(frontmatter: { templateKey: { eq: "index" } }) {
      html
      frontmatter {
        title
        subtitle
        facebook
        soundcloud
        metaTitle
        metaDescription
        metaImage
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js